import { motion } from "framer-motion";
import { STORY_ORIGIN_IMAGE } from "../../data/site";
import { revealUp, staggerParent, viewportOnce } from "../../lib/motion";

export const Origin = () => {
  return (
    <section data-testid="story-origin" className="py-4 sm:py-6">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <div className="grid w-full overflow-hidden rounded-[28px] bg-paper md:grid-cols-2">
          {/* Image */}
          <div className="relative min-h-[320px] overflow-hidden md:order-1 md:min-h-[560px]">
            <motion.img
              src={STORY_ORIGIN_IMAGE}
              alt="Chicken Labb crispy fried chicken, hand-breaded fresh"
              initial={{ scale: 1.12 }}
              whileInView={{ scale: 1 }}
              viewport={viewportOnce}
              transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
              className="absolute inset-0 h-full w-full object-cover"
              loading="lazy"
              decoding="async"
            />
          </div>

          {/* Copy */}
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            variants={staggerParent}
            className="flex flex-col justify-center px-7 py-12 sm:px-12 sm:py-16 lg:px-16 lg:py-20"
          >
            <motion.p variants={revealUp} className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-labred">
              01 / THE ORIGIN
            </motion.p>
            <motion.h2
              variants={revealUp}
              className="font-display text-3xl leading-[1.05] tracking-tight text-inkred sm:text-4xl lg:text-5xl"
            >
              MOST KITCHENS COOK. OURS CALIBRATES.
            </motion.h2>
            <motion.p variants={revealUp} className="mt-6 max-w-lg font-body text-base leading-relaxed text-inkred/75">
              Chicken Labb was founded in New Jersey to redefine the craft of chicken through
              absolute discipline. We don&apos;t treat cooking as cooking. We treat it as
              engineering: the exact balance of ingredients, flawless technique, and
              precision measured to the millimeter, brought together on one plate.
            </motion.p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
